import { render } from "./ModalCadSolicitacao.vue?vue&type=template&id=ecde3e0a&scoped=true"
import script from "./ModalCadSolicitacao.vue?vue&type=script&lang=js"
export * from "./ModalCadSolicitacao.vue?vue&type=script&lang=js"

import "./ModalCadSolicitacao.vue?vue&type=style&index=0&id=ecde3e0a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecde3e0a"]])

export default __exports__